/**
 * Service for retrieving Employee groups from server
 * handles standard server side errors
 *
 * Created by c_razmuss_a on 22/01/2018.
 */
'use strict';
var $ = require('jquery');
var ajaxHandler = require('./ajaxHandler');

/**
 * GET employee Groups for scheme currently available in session
 * returns object with at least one key,value pair
 */
function getEmployeeGroups() {
    return ajaxHandler.ajaxGetJson({ url: process.env.contextRoot + '/rest/employeeGroups' })
        .then(function(data, textStatus, jqXHR) {
            if (data.employeeGroups && Object.keys(data.employeeGroups).length > 0) {
                return data.employeeGroups;
            }
            else {
                console.error("Employee groups didn't return expected format " + data.employeeGroup);
                return $.Deferred().reject({}).promise();
            }
        })
        .fail(ajaxHandler.handleError('Could not retrieve employee groups list'));
}

function getCategoryStaffDetails(categoryId) {
    return ajaxHandler.ajaxGetJson({url: process.env.contextRoot + '/rest/category/' + categoryId})
        .then(populateCategoryStaffDetails)
        .fail(ajaxHandler.handleError("Couldn't receive Category cost center or staff id data"));
}

function getCategoryStaffDetailsByPolicyNumber(policyNumber) {
    return ajaxHandler.ajaxGetJson({url: process.env.contextRoot + '/rest/category/policy/' + policyNumber})
        .then(populateCategoryStaffDetails)
        .fail(ajaxHandler.handleError("Couldn't receive Category cost center or staff id data"));
}

function populateCategoryStaffDetails(categoryDetailsResponse) {
    var result = {};
    if (categoryDetailsResponse.costCentreDetails && categoryDetailsResponse.costCentreDetails.isCostCentreMandatory) {
        result.costCenter = {};
        result.costCenter.label = categoryDetailsResponse.costCentreDetails.costCentreName;
        result.costCenter.support = categoryDetailsResponse.costCentreDetails.costCentreSupportText;
    }

    if (categoryDetailsResponse.staffIdDetails && categoryDetailsResponse.staffIdDetails.isStaffIdMandatory) {
        result.staffId = {};
        result.staffId.label = categoryDetailsResponse.staffIdDetails.staffIdName;
        result.staffId.support = categoryDetailsResponse.staffIdDetails.staffIdSupportText;
    }
    return result;
}

module.exports.getEmployeeGroups = getEmployeeGroups;
module.exports.getCategoryStaffDetails = getCategoryStaffDetails;
module.exports.getCategoryStaffDetailsByPolicyNumber = getCategoryStaffDetailsByPolicyNumber;


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/services/employeeGroupsService.js
// module id = ABcN
// module chunks = 1 2